const doc = [({"en":({"js":({"admin":({"activities":({"live_nav":({"agenda":"Agenda", "setup":"Setup"})})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;